import { h, Component } from 'preact';
import { Router } from 'preact-router';
import { Provider } from 'react-redux';
import configureStore from '../store'
import Footer from './footer';
import Home from '../routes/home';
import Profile from '../routes/profile';
import Project from '../routes/project';
import ProjectDetails from '../routes/projectDetails';
import ReactGA from 'react-ga';
import { connect } from 'preact-redux'
import { onChangeRoute } from '../shared/actions/routerActions';
import Api from '../lib/api'
import Route from '../routes';


const store = configureStore()

export default class App extends Component {

	/** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */
	// handleRoute = e => {
	// 	this.currentUrl = e.url;
	// 	this.props.onChangeRoute(e);
	// };
	constructor() {
		super();
		this.state = {
			someData: null,
		};

		// Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
		ReactGA.initialize(Api.GA_TRACKING_ID);
		// This just needs to be called once since we have no routes in this case.
		ReactGA.pageview(window.location.pathname);
	}

	componentWillMount() {
		const scriptOne = document.createElement('script');
		scriptOne.src = 'https://jira.iucn.org/s/d41d8cd98f00b204e9800998ecf8427e-CDN/kpmgi/805005/b6b48b2829824b869586ac216d119363/2.2.4.7/_/download/batch/com.atlassian.plugins.jquery:jquery/com.atlassian.plugins.jquery:jquery.js?collectorId=d88db1b6';
		scriptOne.async = true;

		const scriptTwo = document.createElement('script');
		scriptTwo.src = 'https://jira.iucn.org/s/df1dcb60d46443a942269733a83070cf-T/kpmgi/805005/b6b48b2829824b869586ac216d119363/4.0.0/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-UK&collectorId=d88db1b6';
		scriptTwo.async = true;

		document.body.appendChild(scriptOne);
		document.body.appendChild(scriptTwo);

		if(window.location.host == "open.iucn.org")
		{
			var s = document.createElement("script");
			s.type = "text/javascript";
			s.src = "https://www.googletagmanager.com/gtag/js?id=G-K2CYT8DPHP";
			s.setAttribute('async', '');
			document.head.appendChild(s);
			window.dataLayer = window.dataLayer || [];
			function gtag() { dataLayer.push(arguments); }
			gtag('js', new Date());
			gtag('config', 'G-K2CYT8DPHP');
		}

	}

	render() {
		return (
			<Provider store={store}>
				<Route />
			</Provider>
		);
	}
}






// WEBPACK FOOTER //
// ./components/app.js